import config from "config/config"

export const MEDALLIA_FEATURE_FLAG = "medallia"
export const MEDALLIA_SOURCE = config.medallia_source
export const MEDALLIA_FEEDBACK_FORM_ID = config.medallia_feedback_form_id
export const MEDALLIA_LAST_UPDATE = "medalliaLastUpdate"
